import { Injectable } from '@angular/core';
import { dateToStringNoTimeZone } from '@app/shared/helpers/extensions';
import { AvailabilitiesApiService } from './api/availabilities-api.service';

@Injectable({
    providedIn: 'root',
})
export class AvailabilitiesService {
    constructor(private availabilitiesApiService: AvailabilitiesApiService) {}

    public getAvailabilities(
        dateStart: string,
        dateEnd: string,
        showSpinner: boolean = true,
        showCalendarSpinner: boolean = false,
        employeeId: string | undefined = undefined,
        currentDateTime: string = dateToStringNoTimeZone(new Date()),
        guidToIgnore?: string
    ) {
        return this.availabilitiesApiService.getAvailabilities(
            dateStart,
            dateEnd,
            showSpinner,
            showCalendarSpinner,
            employeeId,
            currentDateTime,
            guidToIgnore
        );
    }
}
